module.exports = __webpack_public_path__ + "img/cloud1.4835d4a0.svg";